import React from "react";
import { Link } from "gatsby";
import styled from "styled-components";

const GalleriesSection = styled.section`
  margin: 0;
  padding: 100px 40px;
  background-color: #efefef;

  .grid {
    display: grid;
    max-width: 1280px;
    margin: 0 auto;
    grid-template-columns: repeat(2, 1fr);
    gap: 40px;

    @media (max-width: 800px) {
      grid-template-columns: repeat(1, 1fr);
    }
  }

  & .heading-wrapper {
    margin: 0 0 60px 0;
  }
`;

const GalleryCard = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: inherit;
  aspect-ratio: 9/16;
  padding: 20px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border: 39px solid #fff;
  position: relative;
  overflow: hidden;

  & .gallery-title {
    font-size: 5rem;
    line-height: 5rem;
    font-family: GothamSSm-Bold;
    color: #fff;
    font-weight: 500;
    text-align: center;
    padding: 8px 16px;
    border-radius: 4px;
    z-index: 2;

    @media (max-width: 800px) {
      font-size: 3rem;
      line-height: 3rem;
    }
  }
  & .see-more {
    display: block;
    margin-top:10px;
    padding: 8px 16px;
    border:solid 1px #fff;
    color: #fff;
    font-size: 16px;
  }

  &:hover {
    opacity: 0.9;
    transition: opacity 0.3s ease;
  }
`;

export const GalleriesGrid = ({ content, labels = {} }) => {
  if (
    !content ||
    content.slice_type !== "galleries_grid" ||
    !Array.isArray(content.items)
  ) {
    return null;
  }
  const galleries = content.items
    .map((item) => item.gallery_item?.document)
    .filter(Boolean);

  console.log("INTRO FIELD:", content.primary.intro);

  return (
    <GalleriesSection>
      <div className="heading-wrapper">
        {content.primary?.title?.text && <h1>{content.primary.title.text}</h1>}
        {content.primary?.intro?.text && <h3>{content.primary.intro.text}</h3>}
      </div>

      <div className="grid">
        {galleries.map((gallery) => (
          <GalleryCard
            key={gallery.id}
            to={gallery.url}
            style={{
              backgroundImage: `url(${gallery.data.galleries_single_image?.url})`,
            }}
          >
            <span className="gallery-title">
              {gallery.data.title.text}
            </span>
            <div className="see-more">
              <h4>{labels?.see_more && `${labels.see_more} `}</h4>
            </div>
          </GalleryCard>
        ))}
      </div>
    </GalleriesSection>
  );
};
